// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { newPageInfo, newRouteParamsType } from "@hex-insights/router";
import { User, UserFormat, UserNameFragment } from "@s-i-s-i/see-learning.shared";
import { userHubPageInfo } from "../pageinfo";

type UserForRouteTitle = UserNameFragment;

export const userHubDetailPageInfo = newPageInfo({
	name: "User Detail",
	title: (instance: UserForRouteTitle) => UserFormat.name(instance),
	description: "User detail page.",
	exact: false,
	isLeaf: true,
	parent: userHubPageInfo,
	to: (id: User["id"]) => userHubPageInfo.to + `/${id}`,
	path: userHubPageInfo.path + "/:userID(\\d+)",
	paramsType: newRouteParamsType(userHubPageInfo.paramsType, "userID"),
});
